import './venue-background'
import './password-toggle'
import './seatmaps-background'

(function() {
    // A price type placeholder box with white space characters
    // Hide it when there's no actual text inside
    let emptyElements = document.querySelectorAll(".tn-empty-cart-message, #instructions-choose-zone");
    if(emptyElements && emptyElements.length) {
        emptyElements.forEach(element => {
            if(!element.innerText.length) {
                element.style.display = "none";
            }
        })
    }

    let promoCodeInput = document.querySelector('#tn-utility-nav-inline-promo-code-form-input');
    if(promoCodeInput) {
        promoCodeInput.placeholder = 'Promo code';
    }

    let additionalItemsPage = document.querySelector('.tn-additional-items-page');
    if(additionalItemsPage) {
        document.body.classList.add('state--additional-items')
    }
}())